<template>
  <div v-if="isFinanceAdmin || isAdmin" class="">
    <h3 class="page-title text-center">{{ title }}</h3>
    <cc-list-box
      :columns="columns"
      :rows="certificateList"
      :showPagination="true"
      :pagination="pagination"
      @add="onAdd"
      @edit="onEdit"
      @delete="onDelete"
    ></cc-list-box>
  </div>
</template>

<script>
import router from '@/router';
import ccListBox from '@/components/PettyCash/Certificate/ccListBox.vue';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'cc-list',
  components: {
    ccListBox
  },
  data() {
    return {
      isAdmin: false,
      isFinanceAdmin: false,
      columns: [
        { id: 'company', headerText: 'Company Name', textKey: 'company', width: '10%' },
        { id: 'storeid', headerText: 'Store Code', textKey: 'storeid', width: '8%' },
        { id: 'storeName', headerText: 'Store Name', textKey: 'storeName', width: '20%' },
        { id: 'mainCash', headerText: 'Main Cash as per the DC1 report', textKey: 'mainCash', width: '15%' },
        { id: 'floatCash', headerText: 'Float Cash as per system', textKey: 'floatCash', width: '15%' },
        { id: 'pettyCash', headerText: 'Petty Cash as per system', textKey: 'pettyCash', width: '10%' },
        { id: 'quarter', headerText: 'Quarter', textKey: 'quarter', width: '10%' },
        { id: 'actions', headerText: 'Actions', textKey: 'actions', width: '12%' }
      ]
    };
  },
  mounted() {
    this.user.roles.map(item => {
      if (this.user && this.user.roles) {
        this.user.roles.map(item => {
          if (item.name === 'FINANCE_ADMIN') {
            this.isFinanceAdmin = true;
          }
          if (item.name === 'ADMIN') {
            this.isAdmin = true;
          }
        });
      }
    });
    this.listCertificate({ query: {} });
  },
  computed: {
    title() {
      return 'CC List';
    },
    ...mapState('auth', ['user']),
    ...mapState('pettyCash', ['certificateList', 'certificate', 'pagination'])
  },
  methods: {
    ...mapActions('pettyCash', ['listCertificate', 'deleteOneCertificate']),
    onAdd() {
      router.push('/petty-cash/certificate/cc/form');
    },
    onEdit({ row }) {
      router.push(`/petty-cash/certificate/cc/form/${row.id}`);
    },
    onDelete({ row }) {
      const id = row.id;
      this.deleteOneCertificate({ id, router, redirectUrl: '/petty-cash/certificate/cc/upload' });
    }
  }
};
</script>
